<script setup>
// Che do gop trang: chon vai trang, mot trang, hay tat ca. Day la bo loc trang
// that — cot hoi thoai doc lai lua chon nay qua useSelectedPages.
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import { useSelectedPages } from 'dashboard/composables/useSelectedPages';
import PageCard from './PageCard.vue';
import { ALL_PLATFORMS, filterPages } from './platforms';
import TrangMatKetNoiDialog from './TrangMatKetNoiDialog.vue';
import { trangMatKetNoi, idConKetNoi } from 'dashboard/helper/trangMatKetNoi';

const props = defineProps({
  inboxes: { type: Array, default: () => [] },
});

const emit = defineEmits(['applied']);

const { t } = useI18n();
const { mergedInboxIds, isAllMerged, setMergedInboxes } = useSelectedPages();

const dialogRef = ref(null);
const matKetNoiDialog = ref(null);
const tuKhoa = ref('');
const daChon = ref(new Set());

const moiId = computed(() => props.inboxes.map(inbox => Number(inbox.id)));
const trangHien = computed(() =>
  filterPages(props.inboxes, ALL_PLATFORMS, tuKhoa.value)
);
const chonHet = computed(
  () => daChon.value.size > 0 && daChon.value.size === moiId.value.length
);

const toggle = inbox => {
  const id = Number(inbox.id);
  if (daChon.value.has(id)) daChon.value.delete(id);
  else daChon.value.add(id);
  daChon.value = new Set(daChon.value);
};

const toggleTatCa = () => {
  daChon.value = new Set(chonHet.value ? [] : moiId.value);
};

// ids: lua chon da bo trang mat ket noi (tu popup "Bo qua va tiep tuc").
const apDung = ids => {
  // Chon het = "tat ca trang", luu mang rong de trang moi noi sau nay tu vao.
  // MOT LAN GOI DUY NHAT cho ca ba nhanh (go xung dot 17/09/2026).
  //
  // `setMergedInboxes` ghi CA HAI khoa (KEY_GOP va KEY) trong mot lan goi
  // `updateUISettings`. Ham do tron `settings` vao ban chup `uiSettings.value`
  // doc tai thoi diem goi, nen hai lan goi lien tiep thi lan sau ghi de lan
  // truoc. Ban cu o nhanh nay viet `if (ids) setSelectedInboxes(ids);` roi goi
  // tiep — khong co `else` — nen khi co `ids` (lua chon da bo trang mat ket noi)
  // thi lan goi sau ghi de, va danh sach da loc bi mat.
  //
  // Nhanh main dung `selectAllInboxes()` cho truong hop chon het; no chinh la
  // `setSelectedInboxes([])`, nen mang rong o day cho ket qua y het, va con dat
  // dung KEY_GOP mà ban kia bo sot.
  setMergedInboxes(ids ?? (chonHet.value ? [] : [...daChon.value]));
  dialogRef.value.close();
  emit('applied');
};

// Co trang mat ket noi thi hoi truoc; "Quay lai" de nguyen hop thoai nay.
const apply = () => {
  const ids = chonHet.value ? [] : [...daChon.value];
  const mat = trangMatKetNoi(props.inboxes, ids);
  if (!mat.length) {
    apDung();
    return;
  }
  matKetNoiDialog.value.open({
    trang: mat,
    conLai: idConKetNoi(props.inboxes, ids),
  });
};

const open = () => {
  tuKhoa.value = '';
  daChon.value = new Set(
    isAllMerged.value ? moiId.value : mergedInboxIds.value.map(Number)
  );
  dialogRef.value.open();
};

defineExpose({ open });
</script>

<template>
  <Dialog
    ref="dialogRef"
    width="3xl"
    :title="t('BONBOZ.TRANG_CHINH.GOP_TITLE')"
    :confirm-button-label="t('BONBOZ.TRANG_CHINH.GOP_CONFIRM')"
    :disable-confirm-button="daChon.size === 0"
    overflow-y-auto
    @confirm="apply"
  >
    <div class="flex flex-col gap-4 min-h-[16rem]">
      <div class="flex flex-wrap items-center justify-between gap-3">
        <label
          class="flex items-center gap-2 text-sm cursor-pointer text-n-slate-12"
        >
          <input
            type="checkbox"
            :checked="chonHet"
            class="size-4"
            @change="toggleTatCa"
          />
          {{ t('BONBOZ.TRANG_CHINH.GOP_CHON_TAT_CA') }}
        </label>
        <input
          v-model="tuKhoa"
          type="search"
          class="reset-base w-full sm:w-64 !h-9 !m-0 !text-sm px-3 rounded-lg outline outline-1 outline-[rgb(var(--pk-vien))] bg-n-background text-n-slate-12 placeholder:text-n-slate-10 focus-visible:outline-2 focus-visible:outline-n-brand"
          :placeholder="t('BONBOZ.TRANG_CHINH.TIM_TRANG')"
        />
      </div>

      <div class="grid grid-cols-1 gap-3 sm:grid-cols-2 2xl:grid-cols-3">
        <PageCard
          v-for="inbox in trangHien"
          :key="inbox.id"
          :inbox="inbox"
          selectable
          :selected="daChon.has(Number(inbox.id))"
          @click="toggle"
        />
      </div>
      <p v-if="!trangHien.length" class="text-sm text-n-slate-11">
        {{ t('BONBOZ.TRANG_CHINH.TRONG') }}
      </p>
    </div>
  </Dialog>
  <TrangMatKetNoiDialog ref="matKetNoiDialog" @tiep-tuc="apDung" />
</template>
